export const tutors = [
  {
    id: "ivy",
    name: "Ms. Ivy",
    description:
      "A wise and gentle teacher who loves classic literature and encourages structured thinking.",
    avatar: "ivy",
  },
  {
    id: "bobo",
    name: "Bobo",
    description:
      "A playful bunny who loves emojis, jokes, and making writing fun for everyone.",
    avatar: "ivy",
  },
  {
    id: "codi",
    name: "Codi",
    description:
      "A logical robot who gives clear, structured feedback and helps you improve your writing with precision.",
    avatar: "ivy",
  },
  {
    id: "zeta",
    name: "Prof. Zeta",
    description:
      "A magical storytelling mentor who speaks like a wizard and helps you cast writing spells.",
    avatar: "ivy",
  },
];
